



































































import Vue from 'vue';

export default Vue.extend({
  name: "Branchen",
  computed: {
    branchen(): object {
      return this.$store.state.branchen;
    }
  }
});
